<script setup lang="ts">
import { usePathwayEventOverlay, usePathwayEvents } from '@/composables/game/pathway-events'
import { usePathwayChallengeLeaderboard } from '@/composables/game/leader-board'
import { usePathwayCompletionChallenge } from '@/composables/game/challenges'
import BaseChallengeModal from '@/components/modals/BaseChallengeModal.vue'
import PathwayChallengeBackgroundImage from '@/assets/images/pathway-challenge-modal-background.webp'
import PathwayChallengeIcon from '@/assets/images/pathway-double-arrows-up.png'
import { type CardChallengeLeaderboardPlayer, ChallengeMedal } from '@/types/leaderboard-player'
import { formatUnshortenedNumber } from '@/helpers/utils'
import ChallengeBoardCard2 from '@/components/ChallengeBoardCard2.vue'
import ChallengePrizeItem from '@/components/icons/ChallengePrizeItem.vue'
import DoubleArrowsUpImage from '@/assets/images/pathway-double-arrows-up.png'
import { useWalletConnect } from '@/composables/game/wallet-connect'
import { isPrizePoolNft } from '@/types/shared/player-config'
import SummaryCard from '@/components/SummaryCard.vue'

defineProps<{
	show: boolean
}>()
const emit = defineEmits(['hide'])

const { pathwayEvents } = usePathwayEvents()
const { showFirstPathway } = usePathwayEventOverlay()
const { formattedCountdown, pathwayCompletionChallenge } = usePathwayCompletionChallenge()
const {
  getPathwayChallengeLeaderboard,
  pathwayChallengeLeaderboard: players,
  currentPlayer,
} = usePathwayChallengeLeaderboard()

function onCtaClick() {
  showFirstPathway(pathwayEvents.value)
}
</script>

<template>
  <BaseChallengeModal
    :show="show"
    :challenge="pathwayCompletionChallenge"
    :formatted-countdown="formattedCountdown"
    :on-cta-click="onCtaClick"
    :get-leaderboard="getPathwayChallengeLeaderboard"
    :players="players"
    :current-player="currentPlayer"
    background-color="bg-[linear-gradient(180deg,_#EED652_0.01%,_#4F59AF_23.08%,_#000_36.54%)]"
    :background-image="PathwayChallengeBackgroundImage"
    :main-image="PathwayChallengeIcon"
    main-image-class="size-[144px]"
    main-image-background-class="size-[154px] bg-[rgba(231,46,109,0.44)] blur-[36px]"
    :with-stars="true"
    timer-background-class="bg-[linear-gradient(90deg,#EED652_6.18%,#4F59AF_53.24%,#000_86.74%)]"
    title="Pathway challenge"
    description="Complete the most pathways and earn rewards! Make sure to "
    cta-text="Complete pathways"
    rule-card-line1="Complete"
    rule-card-line2="pathways"
    :rule-card-image="PathwayChallengeIcon"
    :score-image="PathwayChallengeIcon"
    @hide="emit('hide')"
  />
</template>
